import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays, User } from "lucide-react";
import { BLOGS } from "../mock";

export default function Blog() {
  return (
    <div>
      <section className="bg-gradient-to-br from-[#0a2540] to-[#1e40af] text-white py-16">
        <div className="container-x">
          <div className="text-xs uppercase tracking-[3px] opacity-80">Insights</div>
          <h1 className="brand-serif text-4xl md:text-5xl font-extrabold mt-2">Our Blog</h1>
          <div className="text-sm mt-4 opacity-80"><Link to="/" className="hover:text-amber-300">Home</Link> / Blog</div>
        </div>
      </section>

      <section className="section">
        <div className="container-x grid md:grid-cols-3 gap-6">
          {BLOGS.map((b) => (
            <article key={b.id} className="blog-card">
              <div className="blog-thumb"><img src={b.image} alt={b.title} /></div>
              <div className="p-6">
                <div className="text-xs text-slate-500 flex items-center gap-3">
                  <span className="flex items-center gap-1"><CalendarDays size={12} /> {b.date}</span>
                  <span className="flex items-center gap-1"><User size={12} /> {b.author}</span>
                </div>
                <h3 className="text-[#0a2540] font-bold text-lg mt-3">{b.title}</h3>
                <p className="text-sm text-slate-600 mt-3 leading-relaxed">{b.excerpt}</p>
                <a href="#" className="mt-4 inline-flex items-center gap-1 text-[#1e40af] text-sm font-semibold">Read More <ArrowRight size={14} /></a>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
